
import { defineComponent, reactive, ref } from "vue";
import { useRoute } from "vue-router";

import billDetail0 from "./bill-detail-0.vue"
import billDetail1 from "./bill-detail-1.vue"
import billDetail2 from "./bill-detail-2.vue"

export default defineComponent({
  name: "BillDetail",
  components: {
    billDetail0,
    billDetail1,
    billDetail2,
  },

  setup() {
    const route = useRoute()

    const formData = reactive({
      type: "0", // 账单类型  0：运费账单 1：理赔加收账单 2: 跨期结算
    });
    const tabs = ref([
      {
        label: "运费账单",
        value: "0",
      },
      {
        label: "理赔加收账单",
        value: "1",
      },
      {
        label: "跨期结算",
        value: "2",
      },
    ]);
    
    // tab页签相关
    const tabClick = (val: string) => {
      formData.type = val;
    };
    

    return {
      tabClick,
      tabs,
      formData,
      route,
    };
  },
});
